import { useQuery } from 'react-query';

import { getProjectDatesForResourceChart as queryFn } from 'api/endPoints/getProjectDatesForResourceChart';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetProjectDatesForResourceChart = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getProjectDatesForResourceChart', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.lastMetaDataId) && Boolean(params.comparedMetaDataId),
    });
};

export interface QueryParams {
    lastMetaDataId: number | undefined;
    comparedMetaDataId: number | undefined;
}

export interface QueryResponse {
    endProjectDate: number;
    startProjectDate: number;
}
